/*
                               (
                              (/(
                              (//(
                              (///(
                             (/////(
                             (//////(                          )
                            (////////(                        (/)
                            (////////(                       (///)
                           (//////////(                      (////)
                           (//////////(                     (//////)
                          (////////////(                    (///////)
                         (/////////////(                   (/////////)
                        (//////////////(                  (///////////)
                        (///////////////(                (/////////////)
                       (////////////////(               (//////////////)
                      (((((((((((((((((((              (((((((((((((((
                     (((((((((((((((((((              ((((((((((((((
                     (((((((((((((((((((            ((((((((((((((
                    ((((((((((((((((((((           (((((((((((((
                    ((((((((((((((((((((          ((((((((((((
                    (((((((((((((((((((         ((((((((((((
                    (((((((((((((((((((        ((((((((((
                    ((((((((((((((((((/      (((((((((
                    ((((((((((((((((((     ((((((((
                    (((((((((((((((((    (((((((
                   ((((((((((((((((((  (((((
                   #################  ##
                   ################  #
                  ################# ##
                 %################  ###
                 ###############(   ####
                ###############      ####
               ###############       ######
              %#############(        (#######
             %#############           #########
            ############(              ##########
           ###########                  #############
          #########                      ##############
        %######

        Powered by Knish.IO: Connecting a Decentralized World

Please visit https://github.com/WishKnish/KnishIO-Client-JS for information.

License: https://github.com/WishKnish/KnishIO-Client-JS/blob/master/LICENSE
*/
import MutationProposeMolecule from './MutationProposeMolecule.js'
import ResponseTransferTokens from '../response/ResponseTransferTokens.js'

/**
 * Query for moving tokens between wallets
 */
export default class MutationTransferTokens extends MutationProposeMolecule {
  /**
   * Fills the Molecule with provided wallet and amount data
   *
   * @param recipientWallet
   * @param amount
   */
  fillMolecule ({
    recipientWallet,
    amount
  }) {
    this.$__molecule.initValue({
      recipientWallet,
      amount
    })
    this.$__molecule.sign({})
    this.$__molecule.check(this.$__molecule.sourceWallet)
  }

  /**
   * Fills the Molecule for a MULTI-recipient transfer (WP line 544)
   *
   * @param {Wallet[]} recipientWallets
   * @param {number[]} amounts - parallel to recipientWallets
   */
  fillMoleculeMulti ({
    recipientWallets,
    amounts
  }) {
    this.$__molecule.initValues({
      recipientWallets,
      amounts
    })
    this.$__molecule.sign({})
    this.$__molecule.check(this.$__molecule.sourceWallet)
  }

  /**
   * Builds a Response object out of a JSON string
   *
   * @param {object} json
   * @return {ResponseTransferTokens}
   */
  createResponse (json) {
    return new ResponseTransferTokens({
      query: this,
      json
    })
  }
}
